import React from "react";
import { Icon, IconProps } from "./icon";

import { ReactComponent as PersonIcon } from "./person.svg";

export const IconPerson = ({width = '24px', height = '24px'}: IconProps) => 
  <Icon src={PersonIcon} width={width} height={height} />;